export default __webpack_public_path__ + "static/media/Background_00235.caeb1aa7.png";